<template>
     <!-- 撤回 弹框 -->
    <el-dialog
        :closeOnClickModal='false'
        width="40%"
        title="撤回"
        :before-close="beforeClose"
        :visible="true"
        class="revocationDialog">

        <el-form>
            <div class="reason">
                <el-form-item>
                    <el-select v-model="recallReasonType" placeholder="撤回原因" clearable style="width: 200px">
                        <el-option
                            v-for="(item, index) in reasonOptions"
                            :filterable="true"
                            :key="index"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input
                        v-model.trim="recallReason"
                        type="textarea"
                        :rows="4"
                        maxlength="50"
                        placeholder="撤回备注">
                    </el-input>
                </el-form-item>
            </div>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="confirm">确 认</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { getDictionaryDetailByCode } from '../../../../api/common';

export default {
    props: {
        revocationShow: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            recallReason: '',
            recallReasonType: '',
            reasonOptions: [],
            dialogLoading: {} // 弹框loading实例
        };
    },
    methods: {
        loading(status = true) {
            if (status) {
                this.dialogLoading = this.$loading({
                    target: '.revocationDialog > div',
                    background: 'rgba(255, 255, 255, .7)'
                });
            } else {
                this.dialogLoading.close();
            }
        },
        confirm() {
            if (!this.recallReasonType) {
                this.$message.warning('请选择撤回原因');
                return false;
            } else if (!this.recallReason) {
                this.$message.warning('请填写撤回备注');
                return false;
            }
            this.$emit('confirm', { recallReasonType: this.recallReasonType, recallReason: this.recallReason });
        },
        beforeClose() {
            this.$emit('update:revocationShow', false);
        },
        // 获取撤回原因
        async getReason() {
            let dataObj = JSON.parse(localStorage.getItem('SYS_TMS_REASON_TYPE'));
            if (!dataObj) {
                const params = {
                    dictCodes: 'SYS_TMS_REASON_TYPE'
                };
                await getDictionaryDetailByCode(params).then(res => {
                    dataObj = res.data.SYS_TMS_REASON_TYPE;
                    localStorage.setItem('SYS_TMS_REASON_TYPE', JSON.stringify(dataObj));
                });
            }
            Object.keys(dataObj).forEach(key => {
                this.reasonOptions.push({
                    label: dataObj[key],
                    value: key
                });
            });
        }
    },
    created () {
        // 获取撤回原因
        this.getReason();
    }
};
</script>
